<div style="height: 40px" class="table-viewer-footer z-depth-1 border-top">
  <y42-scrollbar-wrapper style="height: 40px" class="w-full" [widthUpdated]="false" [arrowRight]="0">
    <table class="w-full h-full">
      <tr>
        <td *ngIf="showPreviewRow" class="detail-row border-right" [matTooltip]="previewToolTip || ''">
          <div class="aligner-start">
            <div>Preview Rows:</div>
            <b style="margin: 0 4px"> {{ previewRows | formatValueConversion }}</b>
            <b>{{ rows ? ' / ' + (rows | formatValueConversion) : '' }}</b>
          </div>
        </td>
        <td class="detail-row border-right">
          Columns: <b>{{ columnsLength }}</b>
        </td>
        <td class="detail-row border-right" *ngIf="cellRangesStats.sum !== null">
          Sum: <b>{{ cellRangesStats.sum | number : '.0-3' }}</b>
        </td>
        <td class="detail-row border-right" *ngIf="cellRangesStats.avg !== null">
          Avg: <b>{{ cellRangesStats.avg | number : '.0-3' }}</b>
        </td>
        <td class="detail-row border-right" *ngIf="cellRangesStats.count !== null">
          Count: <b>{{ cellRangesStats.count }}</b>
        </td>
        <td class="detail-row border-right">
          Selected: <b>{{ cellRangesStats.selected }}</b>
        </td>
        <td class="detail-row" *ngIf="showSize">
          Size: <b>{{ size }}</b>
        </td>
      </tr>
    </table>
  </y42-scrollbar-wrapper>
</div>
